import React from 'react';
import Input from 'Components/Input';

const TextArea = ({ fieldProps: { onChange, ...fieldProps }, ...props }) => {
  const handleChange = (e) => onChange(e.target.value);

  return (
    <Input
      variant="textarea"
      className="textarea-field"
      callback={handleChange}
      fieldProps={fieldProps}
      {...props}
    />
  );
};

export default TextArea;
